import { DeleteTimeFrameBulkInput, DeleteTimeFrameBulkResponse, DeleteTimeFrameInput } from '@/models/gen/graphql';

import { DeleteTimeFrameBulkDocument } from '@/api/queries';
import { GraphApiResponse } from '@/api/core';
import { Toast } from '@/models';
import { createNotification } from '@/utils';
import graphApi from '@/api';

type DeleteTimeFrameBulkGraphApiResponse = GraphApiResponse<typeof DeleteTimeFrameBulkDocument>;

const title = 'Delete Time Frames';

const deleteTimeFrameBulkResponseSelector = (res: DeleteTimeFrameBulkGraphApiResponse): DeleteTimeFrameBulkResponse =>
  !res.errors ? res?.deleteTimeFrameBulk : undefined;

const [runDeleteTimeFrameBulk] = graphApi(DeleteTimeFrameBulkDocument);

const deleteTimeFrameBulk = async (ids: string[]): Promise<DeleteTimeFrameBulkResponse> => {
  const input: DeleteTimeFrameBulkInput = { search: ids.map((id: string): DeleteTimeFrameInput => ({ id })) };
  const res = await runDeleteTimeFrameBulk({ input });

  const selected = deleteTimeFrameBulkResponseSelector(res);
  if (selected) createNotification('Success', Toast.Type.SUCCESS, title);
  return selected;
};

export default deleteTimeFrameBulk;
